<script setup lang="ts">
import {Button, Label, RadioButton, SelectButton} from "@/Components/Library";

const {totalActiveFilters} = defineProps<{totalActiveFilters?: number}>();

const filters = defineModel<{
    with: "groups" | "contacts" | null;
    archived: boolean;
}>();

const emit = defineEmits(["apply", "clear"]);
</script>

<template>
    <div>
        <div class="mb-4">
            <h3 class="mb-2 font-semibold">Filter by chat type</h3>
            <div class="mb-4 flex w-full items-center gap-2">
                <SelectButton
                    class="w-full"
                    v-model="filters.with"
                    :options="[
                        {label: 'Groups', value: 'groups'},
                        {label: 'Contacts', value: 'contacts'},
                    ]"
                    option-label="label"
                    option-value="value"
                />
            </div>
            <div class="flex flex-col gap-3">
                <div class="flex items-center gap-1">
                    <RadioButton
                        input-id="active"
                        name="conversation_status"
                        v-model="filters.archived"
                        :value="false"
                    />
                    <Label for="active">Active</Label>
                </div>
                <div class="flex items-center gap-1">
                    <RadioButton
                        input-id="archived"
                        name="conversation_status"
                        v-model="filters.archived"
                        :value="true"
                    />
                    <Label for="archived">Archived</Label>
                </div>
            </div>
        </div>
        <div class="flex gap-2" v-auto-animate>
            <Button class="grow bg-askr-green text-white hover:brightness-110" @click="emit('apply')">Apply</Button>
            <Button
                v-if="totalActiveFilters"
                class="w-10 shrink-0 bg-red-600 text-white hover:brightness-110"
                @click="emit('clear')"
                :icon="{icon: 'mdi:filter-off-outline', width: '24'}"
            />
        </div>
    </div>
</template>

<style scoped></style>
